import { FC } from 'react'
import { Typography } from '@mui/material'
import { SectionHeader } from '../../jiraWizard.styles'

interface Props {
  title: string
  description?: string
}

const WizardSectionHeader: FC<Props> = ({ title, description }) => (
  <SectionHeader>
    <Typography className="section-title">{title}</Typography>
    {!!description && <Typography className="section-description">{description}</Typography>}
  </SectionHeader>
)

export default WizardSectionHeader
